import { useState, useMemo } from 'react';
import { projects, projectCategories } from '../data/projects';
import { ui } from '../data/ui';
import { SEO } from '../components/ui/SEO';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ProjectCard } from '../components/ui/ProjectCard';
import { FilterBar } from '../components/ui/FilterBar';
import { ProjectCategory } from '../types';

export function ProjectsPage() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filtered = useMemo(() => {
    if (activeFilter === 'all') return projects;
    return projects.filter((p) =>
      p.categories.includes(activeFilter as ProjectCategory)
    );
  }, [activeFilter]);

  return (
    <>
      <SEO title={ui.seo.projects} description={ui.projects.allProjectsSub} />

      <div className="page-header">
        <div className="container">
          <SectionHeader
            label={ui.sections.portfolio}
            title={ui.projects.allProjects}
            subtitle={ui.projects.allProjectsSub}
            align="center"
          />
        </div>
      </div>

      <section className="section">
        <div className="container">
          <FilterBar
            categories={projectCategories}
            active={activeFilter}
            onChange={setActiveFilter}
          />

          <div className="projects-grid">
            {filtered.map((project, i) => (
              <ProjectCard key={project.id} project={project} index={i} />
            ))}
          </div>

          {filtered.length === 0 && (
            <p style={{ textAlign: 'center', color: 'var(--color-text-muted)' }}>
              {ui.projects.noProjects}
            </p>
          )}
        </div>
      </section>
    </>
  );
}
